import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Dashboard } from '@/pages';

/**
 * Dashboard Route (Protected)
 * Main dashboard for authenticated users.
 *
 * Search params:
 * - `tab` — active tab; defaults to `'active'`. Drives the Active/Completed
 *   tab bar so the selected tab is bookmarkable and survives page refresh.
 */

const dashboardSearchSchema = z.object({
  tab: z.enum(['active', 'completed']).default('active'),
});

export const Route = createFileRoute('/_authenticated/dashboard')({
  validateSearch: dashboardSearchSchema,
  component: Dashboard,
});
